import React from "react";

function Icon({ name, size, color, style, className }) {
    return (
        <span
            className={`material-symbols-rounded${className ? ` ${className}` : ""}`}
            style={{
                fontSize: size,
                color,
                ...style
            }}
            aria-hidden="true"
        >
            {name}
        </span>
    );
}

export { Icon };
export default Icon;
